import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-picture-container"},[_c(VAvatar,{attrs:{"color":_vm.color,"size":_vm.size}},[(_vm.imageURL)?_c('img',{attrs:{"alt":"Avatar","src":_vm.imageURL}}):_c('span',{style:({ fontSize: _vm.fontSize + 'px' })},[_vm._v(_vm._s(_vm.initials))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }